import { BoxProps, Flex, Text, Tooltip } from '@chakra-ui/react';
import { CheckIcon } from '@sphere/icons';
import { kebab } from 'case';
import { rem } from 'polished';
import { ButtonLink } from '../ButtonLink';

interface Props extends BoxProps {
  items: {
    title: string;
    href?: string;
    active?: boolean;
  }[];
  forwardLabel: string;
  backwardLabel: string;
}

export const Progress = ({ items, forwardLabel, backwardLabel, ...props }: Props) => {
  const activeIndex = items.findIndex(({ active }) => active);

  return (
    <Flex {...props}>
      {items.map(({ title, href }, index, self) => {
        const isActive = index === activeIndex;
        const isCompleted = activeIndex > index;
        const shouldRenderLink = !isActive && href;
        const Component = shouldRenderLink ? ButtonLink : Flex;

        return (
          <Flex
            mr={index + 1 < self.length ? 'space.12' : 0}
            align="center"
            flexShrink={0}
            key={title + index}
          >
            <Tooltip
              label={`${index > activeIndex ? forwardLabel : backwardLabel} ${title.toLowerCase()}`}
              placement="top"
              hasArrow
              arrowSize={8}
              isDisabled={isActive || !href}
            >
              <Component
                p={0}
                boxSize={rem(40)}
                bg={isActive ? 'gray.4' : 'gray.3'}
                rounded="100%"
                color={isActive ? 'white' : 'gray.5'}
                align="center"
                justify="center"
                mr={isActive ? 'space.8' : 0}
                minW="unset"
                fontWeight="medium"
                {...(shouldRenderLink && {
                  href,
                  'data-testid': `progress-${kebab(title)}-button`,
                })}
                _hover={{
                  color: shouldRenderLink ? 'white' : 'auto',
                  bg: shouldRenderLink ? 'gray.4' : 'auto',
                }}
              >
                {isCompleted ? <CheckIcon boxSize={rem(12)} /> : index + 1}
              </Component>
            </Tooltip>
            {isActive && (
              <Text fontSize="lg" fontWeight="normal">
                {title}
              </Text>
            )}
          </Flex>
        );
      })}
    </Flex>
  );
};
